export enum ReportsConstants {
  SET_ACTIVE_TAB = 'SET_ACTIVE_TAB',

  GET_TIME_USAGE_REPORTS_REQUEST = 'GET_TIME_USAGE_REPORTS_REQUEST',
  GET_TIME_USAGE_REPORTS_SUCCESS = 'GET_TIME_USAGE_REPORTS_SUCCESS',
  GET_TIME_USAGE_REPORTS_FAILURE = 'GET_TIME_USAGE_REPORTS_FAILURE',

  SET_FILTER_VALUES = 'SET_FILTER_VALUES',

  SET_CHARTS_VISIBILITY = 'SET_CHARTS_VISIBILITY',
}
